import React from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  TrendingUp, 
  Wallet, 
  Shield,
  Users,
  Zap,
  CheckCircle,
  ArrowRight,
  Leaf
} from "lucide-react";

export default function Services() {
  const opportunities = [
    {
      name: "WeFi - La 1ère DeoBank au Monde",
      category: "Banking Crypto Révolutionnaire",
      icon: Wallet,
      color: "from-blue-500 to-cyan-600",
      apy: "Jusqu'à 18% APR sur stablecoins",
      minInvestment: "0€ - Démarrez GRATUITEMENT",
      benefits: [
        "🏦 1ère DEOBANK MONDIALE - Reconnue par NASDAQ & Forbes",
        "💳 Carte Visa Crypto (virtuelle + physique) - 140M+ marchands",
        "💰 Jusqu'à 18% APR sur stablecoins avec Energy",
        "⛏️ Mining SANS matériel - Revenus passifs automatiques",
        "⚡ Programme Energy - Boosts mining +10% + réduction frais",
        "🏧 Retraits ATM mondiaux - ZÉRO frais de change",
        "🌍 Support 24/7 multilingue - +7000 cryptos supportées",
        "👔 Co-fondée par REEVE COLLINS - Co-fondateur de TETHER (USDT)",
        "🚀 Équipe légendaire : Maksym Sakharov CEO + Reeve Collins Chairman"
      ],
      risk: "Très Faible",
      bestFor: "Débutants absolus et experts - La solution bancaire crypto COMPLÈTE",
      ctaLink: "https://app.wefi.co/register?ref=p9ybxqycq2",
      website: "https://www.wefi.co/"
    },
    {
      name: "BitNest - Web 3.0 Financial System",
      category: "Smart Contract DeFi",
      icon: TrendingUp,
      color: "from-green-500 to-emerald-600",
      apy: "24% en 28 jours via SMART CONTRACT",
      minInvestment: "À partir de petites sommes",
      benefits: [
        "🔥 SMART CONTRACT AUDITÉ - 24% en 28 jours GARANTIS",
        "💰 4 CYCLES DE GAINS : 1j (0.4%), 7j (4%), 14j (9.5%), 28j (24%)",
        "🚀 35M$+ de liquidité - Plateforme solide et prouvée",
        "💎 Parrainage sur 17 NIVEAUX - Revenus exponentiels",
        "📚 Learn to Earn - Payé pour apprendre le Web3",
        "🌍 Communauté mondiale active avec support 24/7",
        "🔐 100% décentralisé - Vous gardez le contrôle",
        "⚡ Retraits automatiques à la fin de chaque cycle"
      ],
      risk: "Modéré",
      bestFor: "Investisseurs DeFi et bâtisseurs de réseau MLM crypto",
      ctaLink: "https://bitnest.me/X9S6L",
      website: "https://bitnest.me/"
    },
    {
      name: "Life Protocol - Token de Croissance",
      category: "DeFi Algorithmique 3ème Génération",
      icon: Leaf,
      color: "from-purple-500 to-pink-600",
      apy: "Croissance prévisible & durable",
      minInvestment: "Accessible à tous",
      benefits: [
        "🌱 TOKEN DE CROISSANCE ALGORITHMIQUE - 3ème génération",
        "📈 Mécanisme unique +10% achat/vente - Croissance PRÉVISIBLE",
        "🏦 LIFE Lend - Prêts décentralisés révolutionnaires",
        "⛓️ Basé sur Binance Smart Chain (BSC) - Frais ultra-bas",
        "🔐 Réserve de valeur sécurisée - Liquidité garantie",
        "💎 Programme d'affiliation - Commissions sur parrainages",
        "📚 Ressources éducatives complètes - Tutoriels & guides",
        "🌍 Communauté internationale active - Support multilingue"
      ],
      risk: "Modéré",
      bestFor: "Investisseurs cherchant une croissance stable et prévisible en DeFi",
      ctaLink: "#",
      ctaText: "Découvrir le LIFE",
      contactText: "💬 Contactez-moi pour votre 1er achat du LIFE",
      website: "https://blog.lifeprotocol.io"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-900 to-purple-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4">
          <Badge className="mb-6 bg-blue-500/20 text-blue-200 border-blue-400">
            🎯 Opportunités Vérifiées
          </Badge>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Opportunités MLM Crypto
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Découvrez les meilleures opportunités de marketing de réseau dans l'écosystème blockchain. 
            Chaque programme est analysé, testé et validé par notre équipe.
          </p>
        </div>
      </section>

      {/* Criteres de selection */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">
            Nos Critères de Sélection
          </h2>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: Shield, label: "Smart Contracts Audités", desc: "Sécurité maximale" },
              { icon: Users, label: "Communauté Active", desc: "Support 24/7" },
              { icon: TrendingUp, label: "ROI Vérifiable", desc: "Résultats réels" },
              { icon: CheckCircle, label: "Légal & Transparent", desc: "Conforme réglementation" }
            ].map((item, index) => (
              <Card key={index} className="text-center border-0 shadow-lg">
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <item.icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <p className="font-semibold text-slate-900">{item.label}</p>
                  <p className="text-sm text-slate-600 mt-1">{item.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Opportunites */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Mes 3 Opportunités Crypto Recommandées 2025
            </h2>
            <p className="text-xl text-slate-600">
              Testées personnellement et validées - Profitez de mes liens de parrainage exclusifs
            </p>
            <div className="mt-6 inline-block bg-gradient-to-r from-orange-50 to-red-50 border-2 border-orange-200 rounded-xl p-4">
              <p className="text-sm font-bold text-orange-900">
                🎁 BONUS EXCLUSIF : En passant par mes liens, vous bénéficiez d'un accompagnement personnalisé gratuit
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {opportunities.map((opp, index) => (
              <Card key={index} className="border-0 shadow-xl hover:shadow-2xl transition-all duration-300">
                <CardHeader>
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${opp.color} flex items-center justify-center shadow-lg`}>
                      <opp.icon className="w-7 h-7 text-white" />
                    </div>
                    <Badge className={
                      opp.risk === "Faible" ? "bg-green-100 text-green-800" :
                      opp.risk === "Très Faible" ? "bg-green-100 text-green-800" :
                      opp.risk === "Modéré" ? "bg-yellow-100 text-yellow-800" :
                      "bg-orange-100 text-orange-800"
                    }>
                      Risque {opp.risk}
                    </Badge>
                  </div>
                  <CardTitle className="text-2xl">{opp.name}</CardTitle>
                  <p className="text-slate-600">{opp.category}</p>
                </CardHeader>
                <CardContent className="space-y-6">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-slate-50 p-4 rounded-lg">
                      <p className="text-sm text-slate-600">Rendement</p>
                      <p className="text-xl font-bold text-slate-900">{opp.apy}</p>
                    </div>
                    <div className="bg-slate-50 p-4 rounded-lg">
                      <p className="text-sm text-slate-600">Investment Min.</p>
                      <p className="text-xl font-bold text-slate-900">{opp.minInvestment}</p>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold text-slate-900 mb-3">✨ Avantages clés:</p>
                    <ul className="space-y-2">
                      {opp.benefits.map((benefit, i) => (
                        <li key={i} className="flex items-start gap-2 text-slate-700">
                          <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="pt-4 border-t border-slate-200 space-y-3">
                    <p className="text-sm text-slate-600">
                      <strong>Idéal pour:</strong> {opp.bestFor}
                    </p>
                    {opp.ctaLink !== "#" ? (
                      <a href={opp.ctaLink} target="_blank" rel="noopener noreferrer">
                        <Button className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold text-lg py-6">
                          🚀 S'Inscrire Maintenant avec Mon Lien
                          <ArrowRight className="w-5 h-5 ml-2" />
                        </Button>
                      </a>
                    ) : (
                      <a href={opp.website} target="_blank" rel="noopener noreferrer">
                        <Button className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white font-bold text-lg py-6">
                          🔗 {opp.ctaText || "Découvrir le Projet"}
                          <ArrowRight className="w-5 h-5 ml-2" />
                        </Button>
                      </a>
                    )}
                    <Link to={createPageUrl("Contact")}>
                      <Button variant="ghost" className="w-full text-blue-600 hover:text-blue-700">
                        {opp.contactText || "💬 Besoin d'aide ? Contactez-moi"}
                        <ArrowRight className="w-4 h-4 ml-2" />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Pourquoi ces 3 opportunités */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">
            Pourquoi Je Recommande Ces 3 Plateformes ?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="border-0 shadow-2xl border-4 border-blue-500 bg-gradient-to-br from-white to-blue-50 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/20 to-cyan-400/20 rounded-full blur-3xl"></div>
              <CardHeader className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white relative">
                <div className="flex items-center justify-between mb-2">
                  <CardTitle className="flex items-center gap-2 text-white">
                    <Wallet className="w-6 h-6" />
                    WeFi - La 1ère DeoBank Mondiale
                  </CardTitle>
                  <Badge className="bg-yellow-400 text-yellow-900 text-xs px-3 py-1 font-bold">
                    🏆 NASDAQ + FORBES
                  </Badge>
                </div>
                <p className="text-sm text-blue-100">Co-fondée par Reeve Collins (Co-fondateur de Tether USDT) + Maksym Sakharov</p>
              </CardHeader>
              <CardContent className="p-6 space-y-4 relative">
                <div className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white p-5 rounded-xl shadow-xl mb-4 border-2 border-blue-400">
                  <p className="text-3xl font-black text-center mb-2">
                    🏦 PREMIÈRE DEOBANK AU MONDE
                  </p>
                  <p className="text-xl font-bold text-center mb-1">
                    0€ POUR COMMENCER
                  </p>
                  <p className="text-sm text-center opacity-90 font-semibold">
                    Carte Visa + Mining + APR 18% - Tout inclus !
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-blue-50 p-3 rounded-lg border-2 border-blue-200 text-center">
                    <p className="text-2xl font-bold text-blue-700">140M+</p>
                    <p className="text-xs text-slate-600">Marchands Visa</p>
                  </div>
                  <div className="bg-cyan-50 p-3 rounded-lg border-2 border-cyan-200 text-center">
                    <p className="text-2xl font-bold text-cyan-700">18%</p>
                    <p className="text-xs text-slate-600">APR Max</p>
                  </div>
                  <div className="bg-blue-100 p-3 rounded-lg border-2 border-blue-300 text-center">
                    <p className="text-2xl font-bold text-blue-800">+10%</p>
                    <p className="text-xs text-slate-600">Boost Mining</p>
                  </div>
                  <div className="bg-cyan-100 p-3 rounded-lg border-2 border-cyan-300 text-center">
                    <p className="text-2xl font-bold text-cyan-800">7000+</p>
                    <p className="text-xs text-slate-600">Cryptos</p>
                  </div>
                </div>

                <p className="text-slate-700 font-semibold">
                  <strong>Reconnue mondialement</strong> - La DeoBank révolutionnaire qui fusionne Web3 et finance traditionnelle.
                </p>
                <div className="space-y-2">
                  <p className="text-sm font-bold text-slate-900 bg-yellow-50 p-2 rounded">⚡ POURQUOI WEFI DOMINE LE MARCHÉ :</p>
                  <ul className="text-sm text-slate-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 font-bold">🏦</span>
                      <span><strong>1ère DeoBank mondiale</strong> - Couverte par NASDAQ & Forbes</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 font-bold">💳</span>
                      <span><strong>Carte Visa physique + virtuelle</strong> - 140M+ marchands</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 font-bold">⛏️</span>
                      <span><strong>Mining sans équipement</strong> - Revenus passifs quotidiens</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 font-bold">⚡</span>
                      <span><strong>Programme Energy</strong> - Boosts +10% & frais réduits</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 font-bold">👔</span>
                      <span><strong>Équipe de LÉGENDE</strong> - Reeve Collins (Co-fondateur Tether USDT) + Maksym Sakharov</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-lg border-2 border-green-300">
                  <p className="text-sm font-bold text-green-900 text-center">
                    🎯 IDÉAL SI : Vous voulez LA solution bancaire crypto complète SANS investissement initial
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-2xl border-4 border-green-500 bg-gradient-to-br from-white to-green-50">
              <CardHeader className="bg-gradient-to-r from-green-600 to-emerald-600 text-white">
                <div className="flex items-center justify-between mb-2">
                  <CardTitle className="flex items-center gap-2 text-white">
                    <TrendingUp className="w-6 h-6" />
                    BitNest - Smart Contract DeFi
                  </CardTitle>
                  <Badge className="bg-yellow-400 text-yellow-900 text-xs px-3 py-1 font-bold">
                    ⚡ 35M$ LIQUIDITÉ
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="p-6 space-y-4">
                <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-5 rounded-xl shadow-xl mb-4 border-2 border-green-400">
                  <p className="text-3xl font-black text-center mb-2">
                    🔐 SMART CONTRACT AUDITÉ
                  </p>
                  <p className="text-2xl font-bold text-center mb-1">
                    24% EN 28 JOURS GARANTIS
                  </p>
                  <p className="text-sm text-center opacity-90 font-semibold">
                    Retraits automatiques - 100% sécurisé
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-green-50 p-3 rounded-lg border-2 border-green-200 text-center">
                    <p className="text-2xl font-bold text-green-700">0.4%</p>
                    <p className="text-xs text-slate-600">Cycle 1 jour</p>
                  </div>
                  <div className="bg-green-50 p-3 rounded-lg border-2 border-green-200 text-center">
                    <p className="text-2xl font-bold text-green-700">4%</p>
                    <p className="text-xs text-slate-600">Cycle 7 jours</p>
                  </div>
                  <div className="bg-green-100 p-3 rounded-lg border-2 border-green-300 text-center">
                    <p className="text-2xl font-bold text-green-800">9.5%</p>
                    <p className="text-xs text-slate-600">Cycle 14 jours</p>
                  </div>
                  <div className="bg-green-600 p-3 rounded-lg border-2 border-green-700 text-center">
                    <p className="text-2xl font-bold text-white">24%</p>
                    <p className="text-xs text-white">Cycle 28 jours</p>
                  </div>
                </div>

                <p className="text-slate-700 font-semibold">
                  <strong>Smart Contract DeFi révolutionnaire</strong> - 35M$+ de liquidité prouvée sur la blockchain.
                </p>
                <div className="space-y-2">
                  <p className="text-sm font-bold text-slate-900 bg-yellow-50 p-2 rounded">⚡ CE QUI REND BITNEST IMBATTABLE :</p>
                  <ul className="text-sm text-slate-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold">🔐</span>
                      <span><strong>Smart contract audité</strong> - Sécurité maximale</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold">💰</span>
                      <span><strong>4 cycles de gains</strong> - Choisissez votre stratégie</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold">📊</span>
                      <span><strong>17 niveaux de parrainage</strong> - Revenus exponentiels</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold">🎓</span>
                      <span><strong>Learn to Earn</strong> - Formation rémunérée</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold">⚡</span>
                      <span><strong>Retraits automatiques</strong> - Fin de chaque cycle</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-lg border-2 border-orange-300">
                  <p className="text-sm font-bold text-orange-900 text-center">
                    🎯 IDÉAL SI : Vous voulez des gains DeFi prouvés + construire un réseau MLM puissant
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-2xl border-4 border-purple-500 bg-gradient-to-br from-white to-purple-50">
              <CardHeader className="bg-gradient-to-r from-purple-600 to-pink-600 text-white">
                <div className="flex items-center justify-between mb-2">
                  <CardTitle className="flex items-center gap-2 text-white">
                    <Leaf className="w-6 h-6" />
                    Life Protocol
                  </CardTitle>
                  <Badge className="bg-yellow-400 text-yellow-900 text-xs px-3 py-1 font-bold">
                    🌱 3ÈME GEN
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="p-6 space-y-4">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-5 rounded-xl shadow-xl mb-4 border-2 border-purple-400">
                  <p className="text-2xl font-black text-center mb-2">
                    🌱 TOKEN DE CROISSANCE
                  </p>
                  <p className="text-xl font-bold text-center mb-1">
                    ALGORITHMIQUE
                  </p>
                  <p className="text-sm text-center opacity-90 font-semibold">
                    Croissance prévisible & durable
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-purple-50 p-3 rounded-lg border-2 border-purple-200 text-center">
                    <p className="text-2xl font-bold text-purple-700">+10%</p>
                    <p className="text-xs text-slate-600">Spread Achat/Vente</p>
                  </div>
                  <div className="bg-pink-50 p-3 rounded-lg border-2 border-pink-200 text-center">
                    <p className="text-2xl font-bold text-pink-700">BSC</p>
                    <p className="text-xs text-slate-600">Blockchain</p>
                  </div>
                  <div className="bg-purple-100 p-3 rounded-lg border-2 border-purple-300 text-center">
                    <p className="text-2xl font-bold text-purple-800">BEP-20</p>
                    <p className="text-xs text-slate-600">Standard</p>
                  </div>
                  <div className="bg-pink-100 p-3 rounded-lg border-2 border-pink-300 text-center">
                    <p className="text-2xl font-bold text-pink-800">24/7</p>
                    <p className="text-xs text-slate-600">Support</p>
                  </div>
                </div>

                <p className="text-slate-700 font-semibold">
                  <strong>Token de croissance 3ème génération</strong> - Une réserve de valeur avec croissance prévisible.
                </p>
                <div className="space-y-2">
                  <p className="text-sm font-bold text-slate-900 bg-yellow-50 p-2 rounded">⚡ PHILOSOPHIE LIFE PROTOCOL :</p>
                  <ul className="text-sm text-slate-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 font-bold">🌱</span>
                      <span><strong>Croissance algorithmique</strong> - Prévisible & durable</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 font-bold">🏦</span>
                      <span><strong>LIFE Lend</strong> - Prêts décentralisés innovants</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 font-bold">📈</span>
                      <span><strong>Mécanisme +10%</strong> - Liquidité & croissance durables</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 font-bold">💎</span>
                      <span><strong>Programme affiliés</strong> - Commissions parrainages</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 font-bold">📚</span>
                      <span><strong>Éducation complète</strong> - Tutoriels & guides</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg border-2 border-purple-300">
                  <p className="text-sm font-bold text-purple-900 text-center">
                    🎯 IDÉAL SI : Vous cherchez une croissance stable et prévisible en DeFi
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 text-center">
            <Card className="border-0 shadow-xl bg-gradient-to-r from-purple-50 to-pink-50">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  💡 Ma Stratégie Gagnante - Triplez Vos Revenus
                </h3>
                <p className="text-slate-700 mb-4 text-lg">
                  Utilisez les <strong>3 plateformes en parallèle</strong> pour des résultats EXPLOSIFS :
                </p>
                <div className="grid md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-blue-50 p-4 rounded-lg border-2 border-blue-300">
                    <p className="font-bold text-blue-900 mb-2">🏦 WeFi - La Base Solide</p>
                    <p className="text-sm text-blue-800">
                      1ère DeoBank + Carte Visa + Mining + APR 18%<br/>
                      = Solution bancaire complète 0€
                    </p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg border-2 border-green-400">
                    <p className="font-bold text-green-900 mb-2">💰 BitNest - Smart Contract DeFi</p>
                    <p className="text-sm text-green-800">
                      Smart contract 24% + 17 niveaux MLM<br/>
                      = Machine à revenus automatiques
                    </p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg border-2 border-purple-300">
                    <p className="font-bold text-purple-900 mb-2">🌱 Life Protocol - Croissance</p>
                    <p className="text-sm text-purple-800">
                      Token algorithmique + LIFE Lend<br/>
                      = Croissance prévisible & durable
                    </p>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-lg border-2 border-orange-300 mb-6">
                  <p className="font-bold text-orange-900 text-center mb-2">
                    🔥 RÉSULTAT : Revenus passifs + Gains garantis + Croissance stable = LIBERTÉ FINANCIÈRE
                  </p>
                </div>
                <Link to={createPageUrl("Contact")}>
                  <Button size="lg" className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700">
                    📞 Appelez-moi pour un plan personnalisé
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
}
